import {CONF} from "../../configs";

export const tabs = [
    {
        label: 'Статистика',
        icon: 'pi pi-chart-pie',
        path: 'stats'
    },
    {
        label: 'Результаты',
        icon: 'pi pi-bolt',
        path: 'results'
    },
    {
        label: 'Календарь',
        path: 'schedule',
        icon: 'pi pi-calendar'
    }
]

export const navi = [
    [
        {
            label: 'таблица',
            icon: 'trophy',
            path: 'standings'
        },
        {
            label: 'шахматка',
            icon: 'scoreboard',
            path: 'chess'
        },
        {
            label: CONF.configName === 'lfl36' ? 'бомбардиры' : 'снайперы',
            icon: 'ball',
            path: 'scorers'
        },
        {
            label: 'ассисты',
            icon: 'boots',
            path: 'assists'
        },
        // {
        //     label: 'mvp',
        //     icon: 'medal',
        //     path: 'mvp'
        // },
        {
            label: 'карточки',
            icon: 'cards',
            path: 'cards'
        }
    ],
    [
        {
            label: 'по дате',
            icon: 'calendar',
            path: 'bydate'
        },
        {
            label: 'по туру',
            icon: 'league',
            path: 'bytour'
        }
    ],
    [
        {
            label: 'по дате',
            icon: 'calendar',
            path: 'bydate'
        },
        {
            label: 'по туру',
            icon: 'league',
            path: 'bytour'
        }
    ]
]
